export const isMac = (): boolean => {
    return /mac|iphone|ipad/i.test(navigator.userAgent)
}

export const isModPressed = (e: { ctrlKey: boolean; metaKey: boolean }): boolean => {
    return isMac() ? e.metaKey : e.ctrlKey
}

export const modKeyName = (): 'Cmd' | 'Ctrl' => {
    return isMac() ? 'Cmd' : 'Ctrl'
}

export interface ShortcutLike {
    code: string
    shiftKey: boolean
    ctrlKey: boolean
}

export const matchShortcut = <T extends ShortcutLike>(
    shortcuts: Array<T>,
    event: { code: string; shiftKey: boolean; ctrlKey: boolean; metaKey: boolean }
): T | undefined => {
    return shortcuts.find(shortcut =>
        shortcut.code === event.code &&
        shortcut.shiftKey === event.shiftKey &&
        shortcut.ctrlKey === isModPressed(event)
    )
}
